<template>
  <!-- 질문11 -->
  <v-layout flex-fill column class="survey-type-02">
    <div class="subheader">최근 2주간 당신의 상태에 대한 문항입니다. </div>
    <div class="question">가장 많이 느낀 감정 3가지를 선택해 주세요.</div>
    <div class="answer">
      <Emotion :multiple="true"
               :maxSelect="3"
               :emotionStrArr="emotionList"
               :answer="answer"
               @emotionChoice="emotionSelected"/>
    </div>
  </v-layout>
</template>

<script>
import store from '@/store'
import { mixinAuth } from '@/mixins'
import Emotion from '@/components/solution/Emotion'

export default {
  components: {
    Emotion
  },
  mixins:[mixinAuth],
  props: ["question", "surveyData", "travelApplStepCd", "memberStepApplCnt"],
  data: () => ({
    offsetTop: 0,
    model: null,
    maxSelect: 3,
    emotionList: [],
    emotionTitleCd: 'SU008',
    emotionDetailCd: 'SU009',
    answer: []
  }),
  created() {
  },
  mounted() {
    this.getTravelEmotionList();
  },
  methods: {
    emotionSelected(emotionSelected) {
      console.log("emotionSelected : " + emotionSelected);
      // 선택된 값 적용시킴
      this.answer = emotionSelected
      this.$emit('emotionSelected', emotionSelected)
    },
    async getTravelEmotionList() {
      console.log("Step 02 - getTravelEmotionList");
      await store.dispatch('getTravelEmotionList', this.$_payload('so', [
        {'emotionTitleCd': this.emotionTitleCd},
        {'emotionDetailCd': this.emotionDetailCd}
      ]))
        .then(res => {
          console.log('Step 02 - getTravelEmotionList : ', res)
          if (res.success) {
            this.emotionList = res.data;

            this.getStepLoadData();
          } else {
            console.log(res.msg)
            this.emotionList = []
          }
        })
        .catch(error => {
          console.error(error)
          this.emotionList = []
        })
        .finally(() => {
        })
    },
    async getStepLoadData() { // 스텝별 저장 데이터를 가져옴.
      console.log('Step 02 - getStepLoadData Call');
      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitNo': this.surveyData.unitNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            if (res.data.reply != undefined && res.data.reply != null) {
              this.answer = res.data.reply.split('|');
              this.$emit('emotionSelected', this.answer);
            }
          } else {
            console.log(res.msg)
            this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          this.answer = [];
        })
        .finally(() => {
        })
    }
  }
}
</script>
